
export const CCPA_OPTOUT_OPTIONS = {
  YES: 'YES',
  NO: 'NO'
};

export const DIALOG_MODE = {
  UNREGISTERED: 'UNREGISTERED',
  ADMIN_REG: 'ADMIN_REG',
  SHOW_NO_CALAFORNIA_RESIDENT: 'SHOW_NO_CALAFORNIA_RESIDENT',
  SHOW_QUALIFYING_QUESTION: 'SHOW_QUALIFYING_QUESTION',
  SUCCESS_OPT_OUT: 'SUCCESS_OPT_OUT',
  FAILURE_OPT_OUT: 'FAILURE_OPT_OUT',
  SHOW_USER_INFO: 'SHOW_USER_INFO'
};

export const BUTTON_TEXT = {
  UNREGISTERED: 'EventGuestSide_StandardDialog_FallbackText_Close__resx',
  ADMIN_REG: 'EventGuestSide_StandardDialog_FallbackText_Close__resx',
  SHOW_NO_CALAFORNIA_RESIDENT: 'EventGuestSide_StandardDialog_FallbackText_Close__resx',
  SHOW_QUALIFYING_QUESTION: '_registrationNavigatorWidget_forwardDefaultDisplayText__resx',
  SUCCESS_OPT_OUT: 'EventGuestSide_StandardDialog_FallbackText_Close__resx',
  FAILURE_OPT_OUT: 'EventGuestSide_StandardDialog_FallbackText_Close__resx',
  SHOW_USER_INFO: 'EventWidgets_Ccpa_CCPALinkText__resx'
};

